/* eslint-disable max-len, max-lines */
import {getContent, getPatchNote, PatchNote, PatchNoteContent, PatchNoteType} from './UIPatchNoteModule'
// import AnnouncementColonistTournament from '@static/images/announcement_colonist_tournament.png'
// import AnnouncementGift from '@static/images/announcement_gift.png'
import AnnouncementColonistShuffle from '@static/images/announcement_shuffle.png'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'

export class PatchNoteData {
    protected readonly patchNotes: PatchNote[]
    protected readonly announcement: string[]

    constructor() {
        this.patchNotes = []
        this.announcement = []

        this.announcement.push(`<a href="/#selectmode=${MatchmakingMatchTypes.UnrankedShuffle}"><img src="${AnnouncementColonistShuffle}" style="width: 100%"></a>`)
        this.announcement.push('<b>JOIN THIS WEEKEND\'S COLONIST QUALIFIER!!! <a href="https://tinyurl.com/colonist4ptourney36" target="_blank">REGISTER HERE</a></b>')
        // this.announcement.push(`<a href="/championship" target="_blank"><img src="${AnnouncementColonistTournament}" style="width: 100%"></a>`)
        // this.announcement.push(`<a href="https://www.youtube.com/@colonistio/?sub_confirmation=1" target="_blank"><img src="${AnnouncementColonistCon24}" style="width: 100%"></a>`)
        // this.announcement.push('Check out our latest video! </b><a href="https://youtu.be/R_hl_CAefrg" target="_blank">1 v 1 Guide!</a>!</b>')
        // this.announcement.push('<iframe style="display: block; margin: 0 auto;" width="560" height="315" src="https://www.youtube.com/embed/xtkDDYhfMHw?si=CugURvk5342Fyj02" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>')
        // this.announcement.push('<b>We are looking for a Community Manager. Check out <a href="/careers" target="_blank">careers</a>!</b>')
        // this.announcement.push(`<a href="https://blog.colonist.io/colonist-io-2023-summary/"><img src="${Announcement2023YearlyStats}" style="width: 100%"></a>`)
        // this.announcement.push(`<a href="/store#gift"><img src="/${AnnouncementGift}" style="width: 100%"></a>`)

        // Jeff

        // Andre

        // Rob

        // Oguz

        // Stan

        // Muhammad
        // [staging] fix login btn on landing page

        // Marc

        // Dang

        // ! PUBLIC PN FORMAT: vxxx.push(getContent(PatchNoteType.xxx, 'Description', ['Thanks to'], 'Before .png', 'After .png', ['FeatureUpvote link']))

        const v281: PatchNoteContent[] = []
        v281.push(getContent(PatchNoteType.Update, 'Disabled chat box in replay mode'))
        v281.push(getContent(PatchNoteType.Update, 'Updated web landing page layout'))
        v281.push(getContent(PatchNoteType.Fix, 'Fixed missing +2VP Foreign Land information on SF+C&K'))
        v281.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed CC25 and Careers pages not scrolling'))

        // Oguz
        // Close rejected trade offers instantly in Colonist Rush gamemode

        // Stan
        // Fix Rush portrait game end screen missing stats button
        // Fix missing timer in landscape game end screen
        // Fix Rush logo scaling mobile landscape
        // Created packages/audio to replace deprecated Sound.ts
        // settings.json search exclude mobile_rn ios and android build outputs
        // Reset trade offers visibility on turn state change (instead of when total active offers is 0)

        // Muhammad
        // remove autosave method in .vscode/settings.json
        // add analytic events for landing page buttons and header login button
        // update web landing page layout
        // fix shuffle banner in patch notes not selecting shuffle card

        // Dang
        // [Mobile web] Redirect new and guest accounts to /mobile

        this.patchNotes.push(getPatchNote(2025, 12, 2, 281, v281))

        const v280: PatchNoteContent[] = []
        v280.push(getContent(PatchNoteType.Update, '[Mobile] New landing page!', undefined, 'https://imgur.com/a/PkQSaue', 'https://imgur.com/a/qrmCshB'))

        // Oguz
        // Fix game log on dice roll in rush mode
        // Stop recording beginner mode games, record Rush mode games instead

        // Stan
        // Rush fix end game animation played again after viewing map
        // Rush fixed player status not showing "Game End"
        // Increase resolution of rush gamemode icon (128x128 -> 256x256)
        // [Mobile Web] Added rotate device dialog for portrait mode

        // Muhammad
        // refactor codebase after homepage redesign
        // remove footer from checkout page
        // remove careers notification code

        // Dang
        // Fix Web landing page slow login button
        // Adjust Web Landing Page footer layout and font size

        this.patchNotes.push(getPatchNote(2025, 11, 25, 280, v280))

        const v279: PatchNoteContent[] = []
        v279.push(getContent(PatchNoteType.Update, 'Added hide trades button', undefined, undefined, 'https://drive.google.com/file/d/1awbCAx_C3l7KkWYtY-LAc-e7UfJlAfyE/view?usp=sharing'))
        v279.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fix referral details sometimes showing twice', undefined, 'https://imgur.com/a/J2wC5Dn', 'https://imgur.com/a/mYYX0hG'))
        v279.push(getContent(PatchNoteType.Fix, 'Fixed Shuffle link not working in notification panel'))
        v279.push(getContent(PatchNoteType.Fix, 'Fixed trade counter offer creation not working as expected'))

        // Rob
        // HOTFIX 2: Fix shuffle link not working on Android
        // HOTFIX 3: Add new line for mobile push notifications
        // HOTFIX 4: Add analytic event for shuffle notif Play Now link click

        // Oguz
        // [Rush] Prevent spam clicking on vote to end turn button

        // Stan
        // Fixed red timer text in Colonist Rush mode
        // Rush increase card animation speed
        // Rush custom guitar SFX for settlement phase ended
        // Rush added tooltip for next to move robber

        // Muhammad
        // add /sendpushnotificationtoallusers and /sendpushnotificationtome commands to send mobile push notifications
        // mainpage and profilepage banner go to shuffle mode

        // Marc

        // Dang
        // [Mobile Web] Fix Game floating text error is not showing on mobile web
        // [Mobile Web] Fix Action Box get cut off in small height devices
        // [Mobile Web] Fix share link
        // [Mobile Web] Fix extra space at the top of the screen
        // [Mobile Web] Fix barbarian invasion tracker overlaps with other UI in small height devices

        this.patchNotes.push(getPatchNote(2025, 11, 18, 279, v279))

        const v278: PatchNoteContent[] = []
        v278.push(getContent(PatchNoteType.Feature, 'New Matchmaking Mode: Shuffle', undefined, undefined, 'https://imgur.com/a/qK8Tvfe'))
        v278.push(getContent(PatchNoteType.Update, 'Added modes details page', undefined, undefined, 'https://imgur.com/a/redEyyc'))
        v278.push(getContent(PatchNoteType.Update, 'Friend limit for all users increased to 1000'))
        v278.push(getContent(PatchNoteType.Update, 'Renamed map Shuffle Board as Scramble'))
        v278.push(getContent(PatchNoteType.Fix, 'Fix player profile not showing in header on all pages', undefined, 'https://imgur.com/a/Gd4TG8t', 'https://imgur.com/a/A75TtMn'))
        v278.push(getContent(PatchNoteType.Fix, 'Improve homepage layout on larger screens', undefined, 'https://imgur.com/a/2Ihocnv', 'https://imgur.com/a/fwHHMWL'))

        // Jeff
        // Refactor rush files to no longer use CurrentTurnPlayerColor

        // Rob
        // CK monetization free plays ab test
        // Replace "Ranked Cities & Knights" with "Premium Matchmaking" in Plus membership perks
        // Add functionality to send notification panel notifications to users via room command

        // Oguz
        // [Rush] Fix trade related bugs & implement technical feedback on TradeEngine.resetActiveOffersOfPlayer() logic
        // Created different game timers for Colonist Rush and enabled different speed settings for it.
        // Prevent /banmostreportedplayers command from banning players who were reported for chat abuse
        // Fix rush robber icon not appearing on the correct player
        // [Rush] Fix turns auto-skipping while using development cards
        // [Rush] Fix placement confirmation buttons not updating when player controller state changes
        // Fix resource cards are interactable in opponent turns

        // Stan
        // Colonist Rush new end turn button icon and SFX
        // Cleanup unused sprites
        // Fixed chits VP information showing in all SF maps, even when Island Exploration is not active

        // Muhammad
        // hide shuffle card & new badge for logged out users always
        // add info icon to map/mode cards in room
        // update bot and casual 1v1 assets

        // Dang
        // Fixed Player Inventory component update React error
        // Change "Explore Modes" to "Play Online" button in Landing page. before: https://imgur.com/a/bNQx73g after: https://imgur.com/a/K5UIbJY
        // [Mobile] Shows coins on the top header. before: https://imgur.com/a/CPAFs7D after: https://imgur.com/a/4eHRoDE

        this.patchNotes.push(getPatchNote(2025, 11, 11, 278, v278))

        const v277: PatchNoteContent[] = []
        v277.push(getContent(PatchNoteType.Update, 'New landing page', undefined, 'https://imgur.com/a/8hnXiUr', 'https://imgur.com/a/c6hbH5i'))
        v277.push(getContent(PatchNoteType.Update, '[Discord] Change "Create Room" and "Join Room" buttons to "Play With Friends" button in Lobby', undefined, 'https://imgur.com/a/37LkRzB', 'https://imgur.com/a/N2fHxh1'))
        v277.push(getContent(PatchNoteType.Fix, 'Fixed selected language not persisting between pages'))
        v277.push(getContent(PatchNoteType.Fix, 'Fixed game screen overflowing in very small devices', undefined, 'https://imgur.com/a/Qj90vuL', 'https://imgur.com/a/hrwy0FK'))
        v277.push(getContent(PatchNoteType.Fix, 'Fixed Home and Rematch buttons being too small in end game screen', undefined, 'https://imgur.com/a/F6ZLoCd', 'https://imgur.com/a/Vnh5nuL'))

        // Jeff
        // Hotfix ranked end date

        // Rob
        // Fix shuffle queue job scheduling
        // 3P maps no longer supported for 56P seafarers game modes

        // Oguz
        // Created different game timers for Colonist Rush and enabled different speed settings for it.
        // Replaced error popups on development card usage with helper text (floating text)

        // Stan
        // Fixed rush background resizing
        // Colonist Rush added custom game started sound
        // Better webgl inactive popup for mobile app users

        // Muhammad
        // v277.push(getContent(PatchNoteType.Feature, 'New Shuffle Mode!', undefined, undefined, 'https://imgur.com/a/phfglZU'))
        // fix page paddings
        // abtest for shuffle beta

        // Dang
        // Fixed too few number of messages that can be displayed in game chat and logs windows without scrolling for big screens

        this.patchNotes.push(getPatchNote(2025, 11, 5, 277, v277))

        const v276: PatchNoteContent[] = []
        v276.push(getContent(PatchNoteType.Update, 'Improved page responsiveness on larger screens', undefined, 'https://imgur.com/a/um5Gspt', 'https://imgur.com/a/cPrnghS'))
        v276.push(getContent(PatchNoteType.Fix, 'Fixed Progress Cards appearing in Aqueduct popup', undefined, 'https://drive.google.com/file/d/12ECFVLqgDTbyLQpvzT1j10jR9vq4xkTk/view?usp=sharing'))
        v276.push(getContent(PatchNoteType.Fix, 'Fixed showing rematch button for spectators')) // @MUHAMMAD PENDING BEFORE/AFTER IMAGES
        v276.push(getContent(PatchNoteType.Fix, 'Fixed triple ads sometimes showing on the homepage', undefined, 'https://imgur.com/a/mxI1dZa', 'https://imgur.com/a/wQW0eGN'))
        v276.push(getContent(PatchNoteType.Fix, 'Fixed incorrect resource cards tooltips for Seafarers and Cities & Knights modes', undefined, 'https://imgur.com/a/dH5kyIj', 'https://imgur.com/a/LSXHqRo'))
        v276.push(getContent(PatchNoteType.Fix, 'Fixed no dice roll sound in mobile'))
        v276.push(getContent(PatchNoteType.Fix, 'Fixed starting a counter offer adding extra resource cards in trade UI', undefined, 'https://imgur.com/a/YMyZKfa', 'https://imgur.com/a/SNFwT5D'))
        v276.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed City Improvement order in Cities & Knights', undefined, 'https://imgur.com/a/YXTNYQC', 'https://imgur.com/a/xEDY38N'))

        // Rob
        // Shuffle matchmaking queue backend
        // CK monetization test (control, 3 free games, daily dice roll)
        // Wait for user state to load before updating mm ranked cards

        // Oguz
        // Bug fixes and improvements for Colonist Rush
        // [Rush] Fix trade creation UI and discard popup overlapping with each other

        // Stan
        // Removed "many points" replay highlight

        // Muhammad
        // remove endgame tip abtest for bot players
        // re-add ingame vli ads ejs
        // re-add web/discord landing pages

        // Dang
        // Fix resizing too fast messes up resources in Trade UI
        // Fixed scroll area next to the player views area should zoom in/out map instead of scrolling the player views area

        this.patchNotes.push(getPatchNote(2025, 10, 28, 276, v276))

        const v275: PatchNoteContent[] = []
        v275.push(getContent(PatchNoteType.Update, 'New web & discord layout!', undefined, 'https://imgur.com/a/iPgzRXA', 'https://imgur.com/a/1oy9HsS'))
        v275.push(getContent(PatchNoteType.Update, 'New mobile layout!', undefined, 'https://imgur.com/a/jJVbuvq', 'https://imgur.com/a/sSYVUzi'))
        v275.push(getContent(PatchNoteType.Fix, 'Fixed game UI being zoomed out'))
        v275.push(getContent(PatchNoteType.Fix, 'Fixed discarding random cards despite already having cards selected'))
        v275.push(getContent(PatchNoteType.Fix, 'Fixed hover action buttons not appearing for ships in Seafarers'))
        v275.push(getContent(PatchNoteType.Fix, 'Fixed City Improvement order in Cities & Knights'))
        v275.push(getContent(PatchNoteType.Fix, 'Fixed dice sound playing twice in some browsers'))
        v275.push(getContent(PatchNoteType.Fix, 'Fixed bank trade mode not being the default in 1v1 matchmaking games'))
        v275.push(getContent(PatchNoteType.Fix, 'Fixed current turn player\'s color not being visible in landscape mode'))

        // Muhammad
        // remove duplicate hidden classes
        // remove gap between holiday ad and cta btn below it
        // revert ab test for store membership ctas
        // fix reactivation messages not being sent to all users when it couldn't be sent to a single user

        this.patchNotes.push(getPatchNote(2025, 10, 21, 275, v275))

        const v274: PatchNoteContent[] = []
        v274.push(getContent(PatchNoteType.Update, '[Mobile] Back button from /rules now returns to the previous page'))
        v274.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed cutoff items list in /profile', undefined, 'https://imgur.com/a/dkYbURr', 'https://imgur.com/a/sKyAvo2'))
        v274.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed /community page responsiveness', undefined, 'https://imgur.com/a/ktF949B', 'https://imgur.com/a/BNuxwtD'))
        v274.push(getContent(PatchNoteType.Fix, 'Fixed joining a room from the lobby not working'))
        v274.push(getContent(PatchNoteType.Fix, 'Fixed Inventor Progress Card usage after build actions'))
        v274.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed closing keyboard breaking the game in iOS 26'))

        // Stan
        // Fix trade hints restricting selected cards outside beginner mode
        // Fix tablet 56p map interactions

        // Muhammad
        // remove duplicate hidden classes
        // remove gap between holiday ad and cta btn below it
        // revert ab test for store membership ctas
        // small ui fixes to new mobile mode selector and analytic event fixes

        this.patchNotes.push(getPatchNote(2025, 10, 14, 274, v274))

        const v273: PatchNoteContent[] = []
        v273.push(getContent(PatchNoteType.Update, 'Friend requests are automatically accepted when both users add each other'))
        v273.push(getContent(PatchNoteType.Fix, 'Fixed room share link sometimes being incorrect', undefined, 'https://imgur.com/a/Ng3E1cN', 'https://imgur.com/a/SkZxdoj'))
        v273.push(getContent(PatchNoteType.Fix, 'Fixed Manage button not working in profile settings'))

        // Oguz
        // Fix hover action buttons disappearing on opponent actions in Colonist Rush
        // Fix allowable actions on corners are not updated after successful knight actions
        // Fix trade offers closing after every player action in Colonist Rush

        // Stan
        // Convert barbarian invasion tracker to ReactJS
        // Added Colonist Rush map branding
        // Colonist Rush fixed player information views highlighting
        // Colonist Rush added toggle-able next turn button

        // Muhammad
        // revert aditude ad partner back to VLI only
        // new mobile mode selection screen for 50% of users
        // remove valid link list from Discord

        // Marc
        // better handle discord reactivation message errors

        // Pri
        // remove message details in gift noti if no message attached

        this.patchNotes.push(getPatchNote(2025, 10, 7, 273, v273))

        const v272: PatchNoteContent[] = []
        v272.push(getContent(PatchNoteType.Update, 'Added <a href="/championship2025" target="_blank">new qualifiers</a> for Colonist Championship 2025'))
        v272.push(getContent(PatchNoteType.Fix, 'Fixed skip turn button not working in mobile 5-6 player games'))
        v272.push(getContent(PatchNoteType.Fix, 'Fixed missing icons and titles in game logs', undefined, 'https://drive.google.com/file/d/1Mjz2s6kbsYw_GAXOqTybS5OvAZReh_19/view?usp=sharing', 'https://drive.google.com/file/d/19k2XMLt44liGHSCKWu60jvSoUcO1kqn1/view?usp=sharing'))

        // Oguz
        // Added migration script for renaming GameModeSetting enum

        // Stan
        // Removed unused rate notification
        // Bots work in Colonist Rush
        // Fixed non-subscribers changing replay perspective

        // Muhammad
        // move cc25 qualifier and partner data to google sheet https://docs.google.com/spreadsheets/d/1n70Kftu5ELmxM1lF9zFkuuSDndcTuQvtQpDmDOvzFgw/edit?gid=0#gid=0
        // add new ad resellers

        this.patchNotes.push(getPatchNote(2025, 9, 30, 272, v272))

        const v271: PatchNoteContent[] = []
        v271.push(getContent(PatchNoteType.Fix, 'Fixed endgame share image displaying bot icons for players', undefined, 'https://imgur.com/a/pMboEIS', 'https://imgur.com/a/qZLFryy'))
        v271.push(getContent(PatchNoteType.Fix, 'Fixed bot difficulty selector', undefined, 'https://imgur.com/a/aYOGOYl', 'https://imgur.com/a/dn98znd'))

        // Stan
        // Fixed missing icons and titles in logs
        // Fixed counter offers on mobile

        // Muhammad
        // cc25: homepage ad

        this.patchNotes.push(getPatchNote(2025, 9, 24, 271, v271))

        const v270: PatchNoteContent[] = []
        v270.push(getContent(PatchNoteType.Update, 'New <a href="/championship2025" target="_blank">Colonist Championship 2025</a> page', undefined, undefined, 'https://imgur.com/a/PPVcKHX'))
        v270.push(getContent(PatchNoteType.Update, 'Added <a href="/championship2025" target="_blank">new qualifiers</a> for the Championship', undefined, undefined, 'https://imgur.com/a/Piq37w8'))
        v270.push(getContent(PatchNoteType.Update, 'Move logout button to profile settings', undefined, 'https://imgur.com/a/eIKapWW', 'https://imgur.com/a/hSHRHgH'))
        v270.push(getContent(PatchNoteType.Update, '<a href="/press-kit" target="_blank">Press Kit</a> content has been updated'))
        v270.push(getContent(PatchNoteType.Update, 'Clicking user in history opens profile popup', undefined, 'https://imgur.com/a/b5TmQSu', 'https://imgur.com/a/ttYbSeA'))
        v270.push(getContent(PatchNoteType.Update, 'Clicking user in leaderboard opens profile popup', undefined, 'https://imgur.com/a/w3T9fLh', 'https://imgur.com/a/5fyoZYv'))
        v270.push(getContent(PatchNoteType.Update, '[Mobile] Added accounts list and Membership management to your profile', undefined, 'https://imgur.com/a/TsaNhlD', 'https://imgur.com/a/MhkkT1B'))
        v270.push(getContent(PatchNoteType.Fix, 'Fixed overflowing items in profile items tab', undefined, 'https://imgur.com/a/p24HXr3', 'https://imgur.com/a/JNlXwtP'))
        v270.push(getContent(PatchNoteType.Fix, 'Fixed buttons overflowing in end game screen'))
        v270.push(getContent(PatchNoteType.Fix, 'Fixed VP abbreviation in achievements'))
        v270.push(getContent(PatchNoteType.Fix, 'Fixed not being able to discard the 5th Progress Card'))
        v270.push(getContent(PatchNoteType.Fix, 'Fixed Saboteur discard popup text'))
        v270.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed overflowing game logs in landscape mode'))

        // Oguz
        // Add Colonist Rush mode behind feature flag "/togglefeature ColonistRushEnabled"
        // Deprecate CurrentState.actionState and CurrentState.currentTurnPlayerColor

        // Stan
        // Force WebGL to be enabled
        // Fixed Discord content frame using BackCompat mode
        // Fixed iphone mini UIGameActionBox overflow

        // Muhammad
        // [discord] fix undefined logout button
        // /championship25 page ui updates and bug fixes
        // mobile: gift action in room now shows confirmation popup

        // Marc
        // Fix exploit that allowed users to abuse the reward program
        // new job that fixes last job to reactivate Discord inactive users

        // Kyle
        // Bring back discord mobile
        // Priyanka
        // v270.push(getContent(PatchNoteType.Update, 'Press Kit has been updated to reflect new UI'))

        this.patchNotes.push(getPatchNote(2025, 9, 16, 270, v270))

        const v269: PatchNoteContent[] = []
        v269.push(getContent(PatchNoteType.Fix, 'Fixed Gold tile distribution not working during initial placements'))

        // Oguz
        // Add unit tests for exploring the gold tile during initial placement

        // Muhammad
        // mobile: change leaderboard header color to match web
        // mobile: add padding to leaderboard cells
        // mobile: adjust styles for item btns

        // Marc
        // Fix bug where reactivation message was not being sent to users

        // Kyle
        // Integrate react UIGameActionBox on all platforms
        // Fix portrait bank cards overflowing, and mobile keyboard causing bank issues

        this.patchNotes.push(getPatchNote(2025, 9, 9, 269, v269))

        const v268: PatchNoteContent[] = []
        v268.push(getContent(PatchNoteType.Update, 'Fast bots for ranked 4P'))
        v268.push(getContent(PatchNoteType.Update, 'Updated the order of player menu elements in-game', undefined, 'https://imgur.com/a/1vBbicj', 'https://imgur.com/a/MiDMKVw'))
        v268.push(getContent(PatchNoteType.Update, '[Mobile] Updated Mode and Map selectors in room', undefined, 'https://imgur.com/a/yIa9M1j', 'https://imgur.com/a/2VyjLvp'))
        v268.push(getContent(PatchNoteType.Update, '[Mobile] Added ranked info button', undefined, undefined, 'https://imgur.com/a/CKDWrfH'))
        v268.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed chat overflowing when keyboard is open', undefined, 'https://imgur.com/a/nUmg3Vn', 'https://imgur.com/a/GPJaMel'))

        // Jeff
        // Add system to handle experimental game states
        // Fix bug where players could move robber before 7 in CK

        // Rob
        // Update leaderboard season text for mobile
        // Update mobile app internal ad icon

        // Stan
        // Fix friend card on hover in room
        // Fix mobile menu not closing on document click
        // Add discord mobile unsupported popup

        // Muhammad
        // store: subscribed/owned buttons style cleanup
        // web/discord: leave room popup
        // bigger mm popup 'search' button
        // revert ab test for store title

        // Marc
        // Remove AB test to push referrers to invite more friends
        // Remove AB test for share game results

        this.patchNotes.push(getPatchNote(2025, 9, 2, 268, v268))

        const v267: PatchNoteContent[] = []
        v267.push(getContent(PatchNoteType.Update, 'Remove "Ready" button for room hosts', undefined, 'https://imgur.com/a/D9CoCXj', 'https://imgur.com/a/3qShq5e'))
        v267.push(getContent(PatchNoteType.Update, 'Hide trade buttons for spectators', undefined, 'https://i.imgur.com/YeCxHlf.png', 'https://i.imgur.com/zK4QiNj.png'))
        v267.push(getContent(PatchNoteType.Update, 'Updated bottom navigation bar', undefined, 'https://imgur.com/a/Iy6UhbE', 'https://imgur.com/a/uKvW6Nb'))
        v267.push(getContent(PatchNoteType.Update, '[Mobile] Performance improvements'))
        v267.push(getContent(PatchNoteType.Fix, '[Mobile] Fix login page being cut off on smaller screens', undefined, 'https://imgur.com/a/Xrdsfh8', 'https://imgur.com/a/GRKephW'))
        v267.push(getContent(PatchNoteType.Fix, 'Fixed double outline in avatar when using embargo', undefined, 'https://i.imgur.com/ie88uwu.png', 'https://i.imgur.com/CJL0jLq.png'))
        v267.push(getContent(PatchNoteType.Fix, 'Fixed tooltips not being centered in trade offers', undefined, 'https://i.imgur.com/ygSvgCB.png', 'https://i.imgur.com/JqVwHsC.png'))

        // Rob
        // Fix Discord X link

        // Devyesh
        // Added email notification system
        // [Mobile] Updated push notification popup design

        // Stan
        // Convert portrait timer bar to ReactJS
        // Convert replay controls portrait to ReactJS

        // Muhammad
        // increase spacing on homepage/lobby and sidebar
        // revert 'Copied!' text to 'Copy!' in share image popup after 1.5 seconds
        // cleanup chat styles and username color
        // mobile: remove text shadow in mm select
        // v267.push(getContent(PatchNoteType.Update, '[Mobile] Updated bottom navigation bar', undefined, 'https://imgur.com/a/Iy6UhbE', 'https://imgur.com/a/uKvW6Nb'))
        // mobile: use X mark as back button in room pages
        // update ads.txt with aditude

        // Marc
        // web: chat title from 'Room Chat' to 'Chat'
        // mobile: update mobile subscription card background

        // Dang
        // [Mobile] Integrate React.js UIGameCurrentStatus

        this.patchNotes.push(getPatchNote(2025, 8, 26, 267, v267))

        const v266: PatchNoteContent[] = []
        v266.push(getContent(PatchNoteType.Update, 'Redesigned the Advanced Settings in a room', undefined, 'https://imgur.com/a/1JyyMQN', 'https://imgur.com/a/mbHcqAM'))
        v266.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed the room chat being too small while sending a message', undefined, 'https://imgur.com/a/djyy4of', 'https://imgur.com/a/tNj11If'))
        v266.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed trade offer overlaping with player profiles', undefined, 'https://i.imgur.com/mtZZ26V.png', 'https://i.imgur.com/5JEBhYz.png'))
        v266.push(getContent(PatchNoteType.Fix, '[Tablet] Fixed stretched trade offers', undefined, 'https://i.imgur.com/iApHB7d.png', 'https://i.imgur.com/H7w7yoa.png'))
        v266.push(getContent(PatchNoteType.Fix, 'Fixed low resolution avatars in game', undefined, 'https://i.imgur.com/F8p570B.png', 'https://i.imgur.com/OcQxSdB.png'))

        // Devyesh
        // [Mobile] In case colonist.io is not available, prevent redirection to test10 server
        // Add analytic event for membership button on landing page and profile page

        // Stan
        // Integrated ReactJS UI for mobile feeds

        // Muhammad
        // Matchmaking popup - slight UI adjustments
        // only show search bar/button on overview and friends page
        // secondary buttons in popups are now black alpha 50
        // style cleanup for room copy link and title

        // Dang
        // Update endgame screen for losing players (change text, remove animation)

        // Kyle
        // Updated react bank portrait styles
        // integrated react bank on mobile
        // integrated react player informations and bank on web and discord, behind a feature flag

        this.patchNotes.push(getPatchNote(2025, 8, 19, 266, v266))
    }

    getContributionCount(username: string): number {
        let count = 0
        for(const pn of this.getAll()) {
            for(const content of pn.contents) {
                for(const contributor of content.contributors) {
                    if(contributor == username) count += 1
                }
            }
        }
        return count
    }

    getAnnouncements(): string[] {
        return this.announcement
    }

    getAll(): PatchNote[] {
        return this.patchNotes
    }

    getLast5(): PatchNote[] {
        return this.patchNotes.slice(0, 5)
    }

    getLatest(): PatchNote[] {
        return this.patchNotes.slice(0, 1)
    }
}
